<!-- Navbar start -->

<nav class="navbar navbar-expand-lg navbar-dark fixed-top py-0 top-0">
  <div class="container">
    <a class="navbar-brand " href="#"><img class="img-fluid" src="assetses/images/logo.png" alt="Logo"></a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto ms-5">
        <li class="nav-item">
          <a class="nav-link" routerLink="">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/networks">Network</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/hub"> Hub</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/services">Type of services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/cf"> Card Features</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/package"> View Services</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/ai"> Additional Features</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
  <!-- Navbar End -->

<!---HERO SECTION--->
<section class="hero">
  <div class="container">
    <div class="row justify-content-center ">
      <div class="col-md-12">
        <h1 class="hero-heading" data-aos="fade-up">
          <span class="animated-text">From Spotlight to Real Opportunities</span><br>
          <span class="animated-text delay">Empowering Every High School Community</span>
        </h1>
        
      </div>
    </div>
  </div>
  <div class="hero-icon" style="text-align: center; margin-top: 100px;">
    <svg viewBox="0 0 1100 300" xmlns="http://www.w3.org/2000/svg" width="90%" height="200">
      <rect x="125" y="75" width="850" height="150" rx="75" ry="75" fill="none" stroke="#f9fafb" stroke-width="2" stroke-dasharray="10 10" opacity="0.3"></rect>
      <circle r="8" fill="#f9fafb">
        <animateMotion dur="6s" repeatCount="indefinite" calcMode="linear">
          <mpath href="#borderPath"></mpath>
        </animateMotion>
      </circle>
      <path id="borderPath" d="M200,75 
       h700 
       a75,75 0 0 1 0,150 
       h-700 
       a75,75 0 0 1 0,-150 Z" fill="none" stroke="none"></path>
      <text x="550" y="165" font-size="70" font-weight="600" fill="#f9fafb" text-anchor="middle" opacity="0.2" letter-spacing="6">UMYO HIGHSCHOOL</text>
    </svg>
  </div>
 
</section>



<!---END HERO SECTION--->

<!---REVOLUTION SECTION---->

<section>
  <div class="resident bg-light">
    <div class="container">
      <div class="row flex-md-row-reverse">

        <!-- Image Column -->
        <div class="col-lg-6">
          <div class="rounded-4 me-lg-4 mt-lg-5" data-aos="zoom-in-down">
            <img class="img-fluid lozad rounded-4" src="assetses/images/1.jpg" alt="UMYO Highschool Community Hub Image">
          </div>
        </div>

        <!-- Intro Content -->
        <div class="col-lg-6">
          <div class="tribe pt-0">
            <h2 class="purple">Welcome to UMYO Highschool Community Hub</h2>
            <p data-aos="fade-up">
              Welcome to <strong>UMYO Highschool</strong> — a groundbreaking digital ecosystem built for students, alumni, parents, residents, educators, and supporting businesses.
              This isn’t just another social network — it’s a movement designed to uplift, empower, and connect the people who shape our schools and neighborhoods.
            </p>
            <p data-aos="fade-up">
              <strong>UMYO Highschool</strong> is the first and only digital platform designed to unite the entire high school ecosystem — merging features inspired by Instagram, LinkedIn, YouTube, Eventbrite, and community apps — all within a secure, school-driven environment.
            </p>
            <p data-aos="fade-up">
              Here, you’ll find purpose, pride, and real pathways to opportunity. Each digital community inside UMYO Highschool represents a school family — guided by shared values of respect, collaboration, and progress.
              This is a <strong>zero-negativity zone</strong>, intentionally designed to inspire growth and connection among those who care about student success, school spirit, and lifelong learning.
            </p>
            <a href="https://umyohighschool.site/" class="btn btn-hover-purple border-dark gap-2 mt-4" data-aos="fade-up">
              Register Here
            </a>
          </div>
        </div>

        <!-- Subscription Highlight -->
        <div class="col-md-10 mx-auto">
          <div class="tribe pb-0 text-center">
            <p data-aos="fade-up">
              For just <strong>$9.99/month</strong>, members gain access to an unmatched platform dedicated to education, empowerment, and economic opportunity within your school network.
            </p>
            <p data-aos="fade-up"><strong>A Gated Social Network for School Communities.</strong></p>
            <p data-aos="fade-up">
              With UMYO Highschool, you can:
            </p>
          </div>
        </div>

        <!-- Feature List -->
        <div class="col-md-12">
          <div class="tribe welcome">
            <ul class="ps-0">
              <li>✅ Connect with students, alumni, parents, staff, and local businesses</li>
              <li>✅ Build your brand, promote your services, or showcase your school pride</li>
              <li>✅ Spotlight achievements, fundraisers, and student projects</li>
              <li>✅ Create your Digital Talent Card — a multimedia profile with video, links, photos, and testimonials</li>
              <li>✅ Search by name, school, skill, or graduation year</li>
              <li>✅ Share across both UMYO Highschool and major social platforms</li>
            </ul>
            <p data-aos="fade-up" class="mt-3">
              No more disconnection between generations or schools — just a thriving, positive hub where everyone belongs and every voice matters.
            </p>
          </div>
        </div>

        <!-- Additional Info -->
        <div class="col-md-10 mx-auto">
          <div class="tribe text-center">
            <p data-aos="fade-up"><strong>For Students, Alumni, Parents, and Local Supporters</strong></p>
            <p data-aos="fade-up">UMYO Highschool empowers every participant in the school ecosystem to:</p>
            <div class="welcome">
              <ul class="ps-0 text-start  list-unstyled">
                <li>✅ Stay connected with classmates and teachers</li>
                <li>✅ Discover college, trade, or career opportunities</li>
                <li>✅ Access fundraising tools for school programs and clubs</li>
                <li>✅ Support student-led entrepreneurship</li>
                <li>✅ Celebrate milestones and legacy stories from alumni</li>
              </ul>
            </div>
            <p data-aos="fade-up" class="mt-3">
              This is the digital space where <strong>school pride meets real opportunity.</strong>
            </p>
            <p data-aos="fade-up"><strong>If you’re here, you’re part of the movement — one built to rise together.</strong></p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<section>
  <div class="owner py-5 ">
    <div class="container">
      <div class="row">
        <!-- Image Column -->
        <div class="col-lg-6">
          <div class="rounded-4 py-4 mt-lg-5" data-aos="zoom-in-down">
            <img class="img-fluid rounded-4" src="assetses/images/2.jpg" alt="UMYO Business Partnership">
          </div>
        </div>

        <!-- Text Content -->
        <div class="col-lg-6 mt-4 mt-lg-0">
          <div class="tribe welcome">
            <h1 class="purple" data-aos="fade-up">A Game-Changer for Local Businesses & School Sponsors</h1>
            <p data-aos="fade-up">
              For just <strong>$49.99/month</strong>, businesses can become official supporters of the UMYO Highschool network — connecting directly with students, parents, and alumni who value community involvement.
            </p>
            <ul class="ps-0" data-aos="fade-up">
              <li>⭐ Featured in community directories</li>
              <li>⭐ Promoted through livestreams and digital spotlights</li>
              <li>⭐ Aligned with trusted, family-oriented networks</li>
              <li>⭐ Included in student and alumni marketing campaigns</li>
            </ul>
            <p data-aos="fade-up" class="mt-4">
              This isn’t just advertising — it’s <strong>purpose-driven partnership</strong> that invests directly into the next generation.
            </p>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeLKHrOYl6gJqhH5QUCmboAdv5nJId73IEHbtT0GsQPSqAbgw/viewform?usp=header" class="btn btn-hover-purple border-dark gap-2 mt-4" target="_blank" data-aos="fade-up">
              Enter Giveaway
            </a>
          </div>
        </div>
      </div>

      <!-- Secondary Row for Highlights -->
      <div class="row  justify-content-center">
        <div class="col-lg-10">
          <div class="tribe pb-0 welcome text-center">
            <p data-aos="fade-up">
              Each month, featured partners have opportunities to engage with their community through:
            </p>
            <ul class="ps-0  text-start" data-aos="fade-up">
              <li>✅ Student and alumni spotlight collaborations</li>
              <li>✅ Sponsored scholarships or local school events</li>
              <li>✅ Exclusive discounts for school families and members</li>
            </ul>
            <p data-aos="fade-up" class="mt-3">
              Your brand becomes part of a <strong>movement that blends education, entrepreneurship, and community pride</strong> — all within the UMYO Highschool ecosystem.
            </p>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!---END REVOLUTION SECTION---->

<!---BUSINESS SECTION--->
<section class="business bg-light">
  <div class="container">
    <h2 class="text-center mb-5" data-aos="fade-up">Highschool Spotlight & Student Engagement</h2>
    <div class="row text-center mx-md-5">

      <!-- Exposure -->
      <div class="col-md-4 mb-4" data-aos="fade-right">
        <div class="card h-100 rounded-4">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#0d6efd" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 8 8H8V0zM7 1.017V8a1 1 0 0 0 1 1h6.983A7.001 7.001 0 0 1 7 1.017z"/>
            </svg>
          </div>
          <h5>Strategic Exposure</h5>
          <p class="text-muted">Starting at <strong>$109.99/month</strong>, gain visibility across the entire UMYO Highschool network — connecting your brand with students, parents, and alumni.</p>
        </div>
      </div>

      <!-- Giveaways -->
      <div class="col-md-4 mb-4" data-aos="fade-up">
        <div class="card h-100 rounded-4">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="#198754" viewBox="0 0 16 16">
              <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
            </svg>
          </div>
          <h5>Student Giveaways</h5>
          <p class="text-muted">Join student-led contests, scholarships, and monthly recognition campaigns designed to reward creativity and effort.</p>
        </div>
      </div>

      <!-- Sponsorship -->
      <div class="col-md-4 mb-4" data-aos="fade-left">
        <div class="card h-100 rounded-4">
          <div class="mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="#dc3545" viewBox="0 0 16 16">
              <path d="M0 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1.5l3.5-2v9l-3.5-2V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5z"/>
            </svg>
          </div>
          <h5>Scholarships & Recognition</h5>
          <p class="text-muted">Sponsor awards and contests that inspire achievement — and be recognized for empowering the next generation.</p>
        </div>
      </div>

    </div>

    <p class="text-center mt-4 text-muted" data-aos="fade-up">
      Support education. Build trust. Join the UMYO Highschool movement that uplifts school pride and shared growth.
    </p>
  </div>
</section>


<!---END BUSINESS SECTION--->

<!--- DIGITAL SECTION--->

  <!-- Light Section -->
<section class="section dark">
  <div class="content">
    <h2 class="mb-5">🏫 Where School Culture & Community Thrive</h2>
    <p>
      UMYO Highschool allows members to invest directly in their local schools. 
      Through giveaways, listings, exclusive perks, and collaboration tools, the platform builds a circle of support among students, alumni, educators, and local sponsors.
    </p> 
  </div>

  <div class="container my-4 cards">
    <div class="row">

      <!-- Private Access -->
      <div class="col-lg-3 mb-3">
        <div class="card h-100" data-aos="zoom-in-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#0d6efd" viewBox="0 0 16 16">
            <path d="M8 1a7 7 0 0 1 6.938 6.197A5.5 5.5 0 0 1 8 16a5.5 5.5 0 0 1-6.938-8.803A7 7 0 0 1 8 1z"/>
          </svg>
          <p class="fw-semibold">Private, Invitation-Only Access</p>
          <small>Ensures a safe, values-driven school environment.</small>
        </div>
      </div>

      <!-- Collaboration -->
      <div class="col-lg-3 mb-3">
        <div class="card h-100" data-aos="zoom-in-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#198754" viewBox="0 0 16 16">
            <path d="M4 0a2 2 0 0 0-2 2c0 .636.246 1.212.645 1.63C1.22 4.265 0 6.072 0 8c0 2.99 2.31 5.477 5.225 5.946C5.542 14.981 6.076 15 6.61 15h2.78c.534 0 1.068-.02 1.385-.054C13.69 13.478 16 10.99 16 8c0-1.928-1.22-3.735-2.645-4.37C13.754 3.212 14 2.636 14 2a2 2 0 0 0-2-2H4z"/>
          </svg>
          <p class="fw-semibold">Collaboration Tools</p>
          <small>Connect schools, sponsors, and supporters for shared progress.</small>
        </div>
      </div>

      <!-- Perks -->
      <div class="col-lg-3 mb-3">
        <div class="card h-100" data-aos="zoom-in-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#dc3545" viewBox="0 0 16 16">
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2H0V4zm0 3h16v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7z"/>
          </svg>
          <p class="fw-semibold">Exclusive Perks</p>
          <small>Access giveaways, rewards, and early opportunities.</small>
        </div>
      </div>

      <!-- Local Support -->
      <div class="col-lg-3 mb-3">
        <div class="card h-100" data-aos="zoom-in-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#ffc107" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 8 8A8.011 8.011 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
            <path d="M4 8h8v1H4zm0 2h8v1H4zm0 2h5v1H4z"/>
          </svg>
          <p class="fw-semibold">Local Investment</p>
          <small>Every subscription directly supports school programs and local growth.</small>
        </div>
      </div>

    </div>
  </div>

  <div class="content">
    <p>This isn’t just a website — it’s a <strong>movement toward educational empowerment and community legacy.</strong></p>
  </div>
</section>

  <!-- Dark Section -->
<section class="section light">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-5 d-flex justify-content-center align-items-center">
        <div data-aos="zoom-in-down" class="">
          <img class="img-fluid rounded-4" src="assetses/images/3.jpg" alt="UMYO Technology">
        </div>
      </div>
      <div class="col-md-6">
        <div class="content">
          <div class=" position-relative px-md-4 mt-4 mt-md-0">
            <h2 data-aos="fade-up">💡 Powered by UMYO Wall Street of Technology</h2>
            <p data-aos="fade-up"><strong>Where innovation meets education.</strong></p>
            <p class="" data-aos="fade-up ">
              UMYO Highschool is:
            </p>
            <ul class="list-unstyled ps-0 text-start mx-auto d-inline-block">
              <li> 💡 A smart school directory</li>
              <li> 🎓 A digital learning hub</li>
              <li> 💬 A social network for growth</li>
              <li> 💰 A fundraising and business marketplace</li>
            </ul>
            <p data-aos="fade-up">
              We help students, educators, alumni, and supporters get <strong>seen, supported, and connected</strong> — all through cutting-edge technology and community values.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--END POWER SECTION-->

<section class="english">
  <div class="works bg-light">
    <div class="container">
    <h1 class="ms-3 aos-init mb-3 aos-animate" data-aos="fade-up">How It Works?</h1>
      <div class="row">
        <div class="col-md-4 mb-md-0 mb-3 ">
        <div class="p-3 comp h-100 aos-init aos-animate" data-aos="fade-right">
           <h2>
            Private &amp; Safe Digital Communities
           </h2>
           <p>Each union/organization will have its own exclusive digital platform tailored for its members, offering secure private networking.</p>
        </div>          
        </div>
        <div class="col-md-4 mb-md-0 mb-3">
          <div class="p-3 comp h-100 aos-init aos-animate" data-aos="fade-up">
           <h2>
            Comprehensive Services
           </h2>
           <p>Our tech firm will handle all maintenance, hosting, tech support, and day-to-day updates, allowing your union to focus on its core mission.</p>
        </div>
        </div>
        <div class="col-md-4 mb-md-0 mb-3">
          <div class="p-3 comp h-100 aos-init aos-animate" data-aos="fade-left">
           <h2>
            Revenue Sharing
           </h2>
           <p>UMYO shares up to 15% of membership fees with the org/union and up to 15% with its members, creating a sustainable financial model.</p>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!---PRICING SECTION--->
<section class="bg-light pricing py-5">
  <div class="container">
    <h2 class="text-center mb-4" data-aos="fade-up">🎓 UMYO Highschool Network — Launch Packages</h2>
    <p class="text-center text-muted mb-5" data-aos="fade-up">
      Join the movement where education meets community. <br>All memberships include access to private school networks and student-led events.
    </p>
    
    <div class="row text-center justify-content-center">

      <!-- Student & Family Membership -->
      <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-left">
        <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100 p-4">
            <h4 class="card-title">🎒 Student & Family Membership</h4>
            <p class="text-muted fw-semibold">$9.99 / month</p>
            <ul class="list-unstyled ps-3 my-3 text-start">
              <li>5 Digital Cards</li>
              <li>3 Images</li>
              <li>Social Media Links</li>
              <li>Community Access</li>
              <li>Event & Group Invites</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Active Alumni & Leaders -->
      <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-up">
        <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100 p-4">
            <h4 class="card-title">🎓 Active Alumni & Leaders</h4>
            <p class="text-muted fw-semibold">$19.99 / month</p>
            <ul class="list-unstyled ps-3 my-3 text-start">
              <li>20 Digital Cards</li>
              <li>Logo + Custom Banner</li>
              <li>20 Community Posts</li>
              <li>Access to Groups & Mentorship</li>
              <li>Fundraising Tools</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Business & Organization Sponsors -->
      <div class="col-md-6 col-lg-4 mb-4" data-aos="flip-right">
        <div class="membership-cards h-100 shadow rounded-4">
          <div class="card h-100 p-4">
            <h4 class="card-title">🏆 Business & Organization Sponsors</h4>
            <p class="text-muted fw-semibold">$109.99 / month</p>
            <ul class="list-unstyled ps-3 my-3 text-start">
              <li>20 Digital Cards</li>
              <li>3 Images + Logo</li>
              <li>20 Videos or Promotions</li>
              <li>Access to Giveaways & Broadcast Campaigns</li>
              <li>Targeted Community Visibility</li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <p class="note text-center mt-4" data-aos="fade-up">
      🎁 <strong>All members become eligible for weekly giveaways and school-based perks after 60 days.</strong><br>
      📈 <em>Higher tiers earn greater visibility and sponsorship exposure within the UMYO Highschool Network.</em>
    </p>
  </div>
</section>

<!---END PRICING SECTION--->

<!---STROLLING IMAGES SECTION--->
<section class="organization">
  <div class="slider  overflow-hidden" id="logos">
    <div id="gallery1" class="mx-md-0 mx-3">

      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/AI.png" alt=""></a>
      </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Conferencing.png" alt=""></a>
      </div>
      <div class="slide">
      <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Coupons.png" alt="">
      </a>      
       </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Dating.png" alt=""></a>
      </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/DJ.png" alt=""></a>
      </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Estore.png" alt=""></a>
      </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Events.png" alt=""></a>
      </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Fans.png" alt=""></a>
      </div>
      <div class="slide">
        <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Giveaways.png" alt=""></a>
      </div>
      
    </div>

    <div id="gallery" dir="rtl">
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Livestreaming.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Magazine.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Men_No_Pause.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Music.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/News.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Talk.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Tweet.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/Video.png" alt=""></a>
        </div>
        <div class="slide">
          <a href="#"><img class="lozad" src="assetses/images/scrolling_images/VPN.png" alt=""></a>
        </div>      
    </div>
  </div>
</section>
<!---END STROLLING IMAGES SECTION--->


<!-- UMYO Highschool Call & Support Center -->
<section class="bg-white py-5">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="fw-bold" data-aos="fade-up">📞 UMYO Highschool Call & Support Center</h2>
      <p class="text-muted" data-aos="fade-up">
        Our youth-powered call center helps students gain work experience while supporting local fundraising campaigns and school-sponsored initiatives.
      </p>
      <p class="text-muted" data-aos="fade-up">
        When your business or organization registers, our team will assist with setup and organic promotion through the UMYO network — creating visibility that benefits both your brand and the school community.
      </p>
      <p class="fw-semibold" data-aos="fade-up">🎯 50% of every dollar supports students, schools, and educational causes.</p>
      <p class="text-muted" data-aos="fade-up">
        This is community-driven visibility with measurable, long-term impact.
      </p>
    </div>

    <div class="row justify-content-center align-items-start">
      <div class="col-md-5 mb-5" data-aos="fade-right">
        <div class="p-4 shadow rounded-4 bg-light h-100">
          <h3 class="fw-bold mb-3">🌟 Built for Local Entrepreneurs</h3>
          <ul class="fw-semibold ps-0 list-unstyled">
            <li>🙋 Support from real people — youth ambassadors, mentors, and educators guiding you through onboarding</li>
            <li>📲 Your brand promoted across social platforms and within the Atlanta community network</li>
            <li>🎯 Tailored local marketing plans based on your budget and goals</li>
          </ul>
        </div>
      </div>

      <div class="col-md-5 mb-5" data-aos="fade-left">
        <div class="p-4 shadow rounded-4 bg-light h-100">
          <h3 class="fw-bold mb-3">💰 Local Marketing That Gives Back</h3>
          <p class="mb-2"><strong>Every dollar you invest:</strong></p>
          <ul class="fw-semibold ps-0 list-unstyled">
            <li>✨ 50% supports youth programs, local education, and community initiatives</li>
            <li>🤝 50% fuels your brand promotion and local engagement</li>
          </ul>
          <p class="mt-3 fw-semibold">
            This is impact marketing — a cycle of promotion, purpose, and progress for Atlanta.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Scholarships, Awards & Challenges -->
<section class="bg-light py-5">
  <div class="container text-center">
    <h2 class="fw-bold mb-4" data-aos="fade-up">🎓 Scholarships, Awards & Challenges</h2>
    <div class="row justify-content-center">
      <div class="col-md-10">
        <ul class="list-unstyled fw-semibold text-start mx-auto" style="max-width: 700px;">
          <li class="mb-3">🎓 <strong>Weekly Student Scholarships:</strong> Supporting those pursuing higher education, trades, and certifications.</li>
          <li class="mb-3">🏆 <strong>Alumni & Student Recognition Contests:</strong> Celebrating leadership, creativity, and community service.</li>
          <li class="mb-3">💰 <strong>Monthly Fundraising Challenges:</strong> Cash prizes, sponsorships, and exposure for top contributors.</li>
          <li class="mb-3">🛍️ <strong>School Store & Gift Cards:</strong> Redeemable at verified local and alumni-owned businesses.</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- Join the UMYO Highschool Movement -->
<section class="bg-white py-5">
  <div class="container text-center">
    <h2 class="fw-bold mb-4" data-aos="fade-up">🚀 Join the UMYO Highschool Movement</h2>
    <p class="mb-4" data-aos="fade-up">No ads. No negativity. No limits.<br>Just ownership, opportunity, and empowerment — one school at a time.</p>
    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
      <div class="p-4 rounded-4 shadow-sm bg-light" data-aos="zoom-in">
        🌐 <strong>Visit:</strong> <a href="https://umyohighschool.site/" target="_blank">umyohighschool.site</a>
      </div>
      <div class="p-4 rounded-4 shadow-sm bg-light" data-aos="zoom-in">
        🎓 <strong>Students & Parents:</strong> Join for $9.99/month
      </div>
      <div class="p-4 rounded-4 shadow-sm bg-light" data-aos="zoom-in">
        🤝 <strong>Alumni:</strong> Engage & mentor for $19.99/month
      </div>
      <div class="p-4 rounded-4 shadow-sm bg-light" data-aos="zoom-in">
        💼 <strong>Businesses:</strong> Sponsor & promote for $109.99/month
      </div>
    </div>
  </div>
</section>

<!---FAQ SECTION--->
<section class="py-5 bg-light" id="faq">
  <div class="container">
      <div class="row mx-md-5" style="margin-top: 70px;">
        <div class="col-12">
          <h2 class=""><b>UMYO Highschool Community Hub</b></h2>
          <h4 class=" mt-5 mb-3">We Stand On Business <br>Frequently Asked Questions</h4>
          <div class="accordion" id="accordionPanelsStayOpenExample">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    How do we strengthen our schools?
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                      By using platforms designed to give back. Every subscription and promotion helps fund local schools and student programs.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Do I have to leave other social platforms?
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                      No. You can share from UMYO to others — but this is your secure, school-based network where your data and voice matter most.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                   Is UMYO Highschool inclusive?
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                     Yes. Built by educators, innovators, and parents, UMYO Highschool unites all backgrounds through shared purpose.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="headingfour">
                   What are the costs?
                  </button>
                </h2>
                <div id="collapsefour" class="accordion-collapse collapse" aria-labelledby="headingfour" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <ul class="list-group ">
                      <li class="list-group-item">$9.99/month – Students, Parents, Residents</li>


                      <li class="list-group-item">$19.99/month – Alumni & Active Participants</li>


                      <li class="list-group-item">$109.99/month – Businesses & Sponsors</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                   What makes it different? 
                  </button>
                </h2>
                <div id="collapsefive" class="accordion-collapse collapse" aria-labelledby="headingfive" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <ul class="list-group ">
                      <li class="list-group-item">Real-time collaboration & messaging</li>


                      <li class="list-group-item">School-based directories</li>


                      <li class="list-group-item">Scholarships, contests & recognition</li>


                      <li class="list-group-item">Zero-negativity environment</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingsix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsesix">
                   How do I join?
                  </button>
                </h2>
                <div id="collapsesix" class="accordion-collapse collapse" aria-labelledby="headingsix" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <ul class="list-group ">
                      <li class="list-group-item">Visit <a href="https://umyohighschool.site/">umyohighschool.site</a></li> 


                      <li class="list-group-item">Select your role (Student, Parent, Alumni, Business)</li>


                      <li class="list-group-item">Complete registration</li>


                      <li class="list-group-item">Pay securely and receive your invite link</li>
                    </ul>

                  </div>
                </div>
              </div>
              
            </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!---END FAQ SECTION--->


<section>
  <div class="pledge overflow-hidden">
    <div class="container">
      <div class="row" style="margin: 70px 0">
        <div class="col-lg-6">
          <div class="child">
            <h2 class="title aos-init" data-aos="fade-up">
              <span>It Starts With</span> Us. The IAM Pledge.
            </h2>
            <p data-aos="fade-up" class="aos-init">Our communities thrive when we hold ourselves—and each other—accountable. That’s the heart of our digital platforms: to create safe, supportive spaces where every resident commits to something greater. By taking the IAM Pledge, you’re making a personal vow to report violent crimes, protect your neighborhood, and use your voice to uplift others.</p>
            <p data-aos="fade-up" class="aos-init">But safety is only part of the mission. These platforms are also a lifeline—for those facing silent battles. Through mental health awareness and access to supportive tools, we’re breaking the stigma, starting real conversations, and building a culture of compassion.</p>
            <p data-aos="fade-up" class="aos-init">Together, we can create communities that are not only connected—but courageous, informed, and deeply human. This is your platform. This is your pledge. IAM.</p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="child right aos-init" data-aos="flip-up">
            <i class="fa-solid fa-globe text fa-4x "></i>
            <h3 class="title text-center mt-3">The IAM Pledge</h3>
            <span class="text-center d-block">A Commitment to Community, Safety &amp; Mental Wellness</span>
            <ul class="ps-3 mt-3 list-unstyled">
              <li> I pledge to report violent crimes in my community.</li>
              <li> I pledge to stand up, speak out, and protect those around me.</li>
              <li>I pledge to use my voice to break the silence around mental health.</li>
              <li> I pledge to listen, support, and build up those who are struggling.</li>
              <li> I pledge to hold myself accountable—because healing starts with honesty.</li>
              <li> I pledge to be part of the solution, not the silence.</li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <div class="line"></div>
        </div>
      </div>
  </div>
</div>
</section>